import { Modal, Typography } from 'antd';

import { Button } from '@shared/components';

const { Text } = Typography;

const PeopleUnderMyCareModal = () => {
  const onClose = () => {
    Modal.destroyAll();
  };

  return (
    <div className="flex flex-col items-center gap-y-6 text-center">
      <div className="flex flex-col gap-y-4">
        <div className="flex flex-col gap-y-2">
          <Text className="text-base font-bold">My children</Text>
          <Text className="text-center text-sm">For your children who are below 21 years old.</Text>
        </div>

        <Text className="text-center text-sm">
          {`In Children's Health, you can retrieve and view your child/ward's health and medical records which are retrieved
        from Health Promotion Board. These records may not be the latest or the most comprehensive, subject to
        availability and retrieval of updated data from our systems. Records displayed may differ from hard copies of
        health records issued by HPB before 01 Jan 2015.`}
        </Text>
      </div>

      <div className="flex flex-col gap-y-2">
        <Text className="text-base font-bold">Family & friends</Text>
        <Text className="text-center text-sm">
          For your parents, children (21 years and above), relatives or friends.
        </Text>
      </div>

      <Button block onClick={onClose}>
        OK
      </Button>
    </div>
  );
};

export default PeopleUnderMyCareModal;
